import Image from 'next/image';

/*
 * We have 3 slightly different feature grids on the homepage, use cases page, and product page
 * The props for the features grid portion is the same for all 3
 */

export const FEATURE_GRID_FEATURES_PROPS = [
  {
    icon: (
      <Image src="https://front.com/webassets/rebrand/hp-feature-ai-answers.svg" width={32} height={32} alt="Feature Icon AI" className="block" />
    ),
    cta: {
      title: 'Front AI',
      href: 'https://front.com/product/ai',
    },
    description: 'Analyze, assist, and automate to deliver top-quality service',
  },
  {
    icon: (
      <Image
        src="https://front.com/webassets/rebrand/hp-feature-omnichannel.svg"
        width={32}
        height={32}
        alt="Feature Icon Omnichannel Inbox"
        className="block"
      />
    ),
    cta: {
      title: 'Omnichannel',
      href: 'https://front.com/product/omnichannel-support-inbox',
    },
    description: 'Centralize email, SMS, WhatsApp and more for a unified experience',
  },
  {
    icon: (
      <Image
        src="https://front.com/webassets/rebrand/hp-feature-tickets.svg"
        width={32}
        height={32}
        alt="Feature Icon Ticketing"
        className="block"
      />
    ),
    cta: {
      title: 'Ticketing',
      href: 'https://front.com/product/ticketing',
    },
    description: 'Track, manage, and resolve inquiries with flexible ticketing',
  },
  {
    icon: (
      <Image src="https://front.com/webassets/rebrand/hp-feature-chat.svg" width={32} height={32} alt="Feature Icon Chat" className="block" />
    ),
    cta: {
      title: 'Chat',
      href: 'https://front.com/product/live-chat',
    },
    description: 'Help customers in-the-moment with live chat and AI resolutions',
  },
  {
    icon: (
      <Image
        src="https://front.com/webassets/rebrand/hp-feature-workflows.svg"
        width={32}
        height={32}
        alt="Feature Icon Workflows"
        className="block"
      />
    ),
    cta: {
      title: 'Workflows',
      href: 'https://front.com/product/workflows',
    },
    description: 'Build powerful automations that codify your team’s best practices',
  },
  {
    icon: (
      <Image
        src="https://front.com/webassets/rebrand/hp-feature-integrations.svg"
        width={32}
        height={32}
        alt="Feature Icon Integrations"
        className="block"
      />
    ),
    cta: {
      title: 'Integrations',
      href: 'https://front.com/integrations',
    },
    description: 'Sync data and power workflows across multiple systems',
  },
  {
    icon: (
      <Image
        src="https://front.com/webassets/rebrand/hp-feature-analytics.svg"
        width={32}
        height={32}
        alt="Feature Icon Analytics"
        className="block"
      />
    ),
    cta: {
      title: 'Analytics',
      href: 'https://front.com/product/analytics',
    },
    description: 'Get powerful insights to keep evolving your product and services',
  },
  {
    icon: (
      <Image
        src="https://front.com/webassets/rebrand/hp-feature-knowledge-base.svg"
        width={32}
        height={32}
        alt="Feature Icon Knowledge Base"
        className="block"
      />
    ),
    cta: {
      title: 'Knowledge Base',
      href: 'https://front.com/product/knowledge-base',
    },
    description: 'Document answers for faster, more accurate replies',
  },
];
